import React from "react";
import useApplicationRegistrationCookiePopup from "../../../../../Shared/Cookies/ChoicesCookie/useApplicationRegistrationCookiePopup.hook";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { ChartLegendToggleButton } from "./ChartLegendToggleButton";

export const adviceChargesTypes = [
    {
        name: "Initial adviser charge",
        color: "#87C0CD",
        cssModifier: "iac squared",
        wrapperTypeEnum: "InitialAdviserCharge",
    },
    {
        name: "Ongoing adviser charge",
        color: "#3581D7",
        cssModifier: "oac squared",
        wrapperTypeEnum: "OngoingAdviserCharge",
    },
    {
        name: "Regular payment adviser charge",
        color: "#2B3252",
        cssModifier: "rp squared",
        wrapperTypeEnum: "RegularPaymentAdviserCharge",
    },
    {
        name: "Adviser ad hoc charge",
        color: "#FF8A00",
        cssModifier: "adHoc squared",
        wrapperTypeEnum: "AdHocCharge"
    },
    {
        name: "Drawdown Initial Adviser Charge",
        color: "#412738",
        cssModifier: "diac squared",
        wrapperTypeEnum: "DrawdownInitialAdviserCharge",
    },
];

interface IAdviceChargesToggleBarProps {
    types: string[];
    originType: string[];
    onChange: (types) => void;
}

export const AdviceChargesToggleBar = (props: IAdviceChargesToggleBarProps) => {
    const _adviceChargesTypes = adviceChargesTypes.filter((ele) => props.originType?.some((item) => item == ele.name));
    const { addEvent } = new AdviserSiteTagManager();
    return (
        <div className="row narrow-gutter">
            {_adviceChargesTypes.map((bo: any, index: number) => {
                return (
                    <div key={index} className="col-auto pb-8">
                        <ChartLegendToggleButton
                            cssWrapper=" advice-charges-toggle"
                            product={bo}
                            onClick={(v) => {
                                addEvent({
                                    event: "adviserchargestab_interaction",
                                    eventParameters: {
                                        eventAction: "chart filter",
                                        eventCategory: eventCategoryForGTM.adviserChargesTab,
                                        eventLabel: `${bo.name} - ${v ? "yes" : "no"}`,
                                    },
                                });
                                if (v) {
                                    props.onChange(props.types.concat(bo.name));
                                } else {
                                    props.onChange(props.types.filter((ele) => ele != bo.name));
                                }
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};
